import React, { FC, RefObject, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { Box, Button, Dialog, DialogActions, DialogContent, Divider, Grid,TextField, IconButton, MenuItem, Paper, Select, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import CancelIcon from '../../../assets/icons/cancel-icon';
import Table from '../../bulk-device-management/table';
import useStyles from './styles';
import { AppState } from '../../../store';
import { panelFilesHeadCells, panelFilesHeadCellsSortableAccessors, vimsConfigHeadCells, vimsConfigSortableAccessors } from './head-cell';
import VirtualizedTable from '../../virtualized-table';
import {  uploadVimsConfigFile, fetchVimsRtdsTableData, queuePanelConfigManagement, patchPanelConfigManagement, deletePanelConfigManagement} from '../../../store/software-library-management/actions';
import {  ConfigManagementRequestPayload, queueConfigManagementResponse } from '../../../services/types';
import PanelConfigurationManagement from '../../../services/panel-configuration';
import { enqueueSnackbarAction } from '../../../store/snackbar/actions';

type SelectOption = {
    value: string;
    title: string;
};
const generationOfDevices: SelectOption[] = [
  { value: 'GLOBAL', title: 'PLE/PL542' },
  { value: 'GEN5', title: 'PL542' },
  { value: 'GEN6', title: 'PLE' },
  // { value: 'GEN7', title: 'Gen 7' },
  { value: 'PL444', title: 'PL444' },
];

const Panels: SelectOption[] = [
  { value: 'DEFAULT', title: 'DEFAULT' },
  { value: 'ECS 100 / ECS 200', title: 'ECS 100 / ECS 200' },
  { value: 'EMCP 2', title: 'EMCP 2' },
  { value: 'EMCP 3.1', title: 'EMCP 3.1' },
  { value: 'EMCP 3.2', title: 'EMCP 3.2' },
  { value: 'EMCP 3.3', title: 'EMCP 3.3' },
  { value: 'EMCP 4.1', title: 'EMCP 4.1' },
  { value: 'EMCP 4.2', title: 'EMCP 4.2' },
  { value: 'EMCP 4.2B', title: 'EMCP 4.2B' },
  { value: 'EMCP 4.3', title: 'EMCP 4.3' },
  { value: 'EMCP 4.4', title: 'EMCP 4.4' },
  { value: 'EMCP2+', title: 'EMCP2+' },
  { value: 'PW 1.0', title: 'PW 1.0' },
  { value: 'PW 1.1', title: 'PW 1.1' },
  { value: 'PW 1.1+', title: 'PW 1.1+' },
  { value: 'PW 2.0', title: 'PW 2.0' },
  { value: 'PW 2.1', title: 'PW 2.1' },
  { value: 'PW 2.1+', title: 'PW 2.1+' },
  { value: 'TEM', title: 'TEM' },
  { value: 'TPEM', title: 'TPEM' },
  { value: 'DeepSea', title: 'DeepSea' },
  { value: 'DEIF AGC243', title: 'DEIF AGC243' },
  { value: 'DEIF AGC4', title: 'DEIF AGC4' },
  { value: 'ComAp IG200 (IL4)', title: 'ComAp IG200 (IL4)' },
  { value: 'ComAp IG500 G2', title: 'ComAp IG500 G2' },
  { value: 'ComAp MRS15', title: 'ComAp MRS15' },
  { value: 'ComAp MRS16 (IL3)', title: 'ComAp MRS16 (IL3)' },
  { value: 'ComAp MRS16 (IL4)', title: 'ComAp MRS16 (IL4)' },
  { value: 'ComAp AMF25', title: 'ComAp AMF25' },
  { value: 'ComAp NTC BB', title: 'ComAp NTC BB' },
  { value: 'ComAp InteliSys Gas', title: 'ComAp InteliSys Gas' },
  { value: 'EASYGEN 3200', title: 'EASYGEN 3200' },
  { value: 'Datakom FG100', title: 'Datakom FG100' },
  { value: 'Sedemac 1206', title: 'Sedemac 1206' },
  { value: 'Generac H100', title: 'Generac H100' },
  { value: 'PCC 2100/2300/3102/3300', title: 'PCC 2100/2300/3102/3300' },
];
const setPercentUpload = () => { };

const PanelConfigurations: FC = () => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const [generationOfDevice, setgenerationOfDevice] = useState<string>('GLOBAL');
    const [panelName, setPanelName] = useState<string>();
    const [planName, setPlanName] = useState<string>('');
    const [columnVisibility, setColumnVisibility] = useState([]);
    const [columnOrder, setColumnOrder] = useState([]);
    const tableContainer: RefObject<HTMLDivElement> = useRef(null);
    const [selectedItem, setSelectedItem] = useState<number | null>();
    const [vimsFileName, setVimsFileName] = useState<any>();
    const [vimsSha1, setVimsSha1] = useState<string>();
    const reference = useRef<HTMLInputElement>(null);
    const [existingvimsFileName, setExistingVimsFileName] = useState<{
        id: string;
       fileName:string;
       vimsConfigId:string;
    }>();
    const [rtdsConfigDefault, setRtdsConfigDefault] = useState<boolean>(false);
    const [vimsConfigRebootEdit, setVimsConfigRebootEdit] = useState(false);
    const [rtdsConfigDefaultEdit, setRtdsConfigDefaultEdit] = useState<boolean>(false);
    const [selectFromexist, setSelectFromexist] = useState<boolean>(false); 
    const [originalRtdsConfigDefaultEdit, setOriginalRtdsConfigDefaultEdit] = useState(false);
    const [vimsConfigFileName, setVimsConfigFileName] = useState<string>('');
    const [vimsConfigFile, setVimsConfigFile] = useState<any>();
    const [vimsConfigFileUploadData, setVimsConfigFileUploadData] = useState<any>([]);
    const [vimsSha, setVimsSha] = useState<string>('');
    const [vimsConfigId, setVimsConfigId] = useState<any>('');

    const Checkbox = ({ row }: any) => (
        <>
            <input
                type="radio"
                checked={row.id === selectedItem}
                onChange={() => {
                    setSelectedItem(row.id);
                    setExistingVimsFileName({
                        id: row.original.vimsSha1,
                        fileName:row.original.vimsFileName,
                        vimsConfigId: row.original.vimsConfigId,
                    });
                }}
            />
        </>
    );

    const checkColumn = {
        accessor: 'checkbox',
        width: 30,
        Header: '',
        component: Checkbox,
    };

    const vimsTableContainer = useRef<any>();
    const columns = useMemo(() => [checkColumn, ...vimsConfigHeadCells], [checkColumn]);
    const [selectedRows, setSelectedRows] = useState<any>([]);
    const [popoverOpen, setPopoverOpen] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>();
    const [panelTableData, setPanelTableData] = useState<any[]>([]);
    const [openEditPopUp, setOpenEditPopoUp] = useState<boolean>(false);
    const [deleteSelectedRow, setDeleteSelectedRow] = useState<any>([]);
    const [editSelectedRow, setEditSelectedRow] = useState<any>([]);
    const { client, envVariables } = useSelector((state: AppState) => state.login);
    const clientAuth: any = client?.authenticate();
    const userName = clientAuth?.loginId;
    const vimsRtdsTableData = useSelector((state: AppState) => state.libraryManagement.vimsRtdsTableData);
    // Filter unique VIMS files by vimsFileName and vimsSha1, and map GenType to title
  const uniqueVimsFiles = useMemo(() => {
    const seen = new Set();
    return (vimsRtdsTableData || [])
      .filter((item) => {
        const key = `${item.vimsFileName}|${item.vimsSha1}`;
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
      })
      .map((item) => ({
        ...item,
        generationType:
          generationOfDevices.find((gen) => gen.value === item.generationType)?.title || item.generationType,
      }));
  }, [vimsRtdsTableData,generationOfDevices]);
    const fileReader = new FileReader();
  
  const configsForCurrentPanel = panelTableData.filter(
    (row) => row.panelName === panelName
  );
  const isPanelLimitReached = configsForCurrentPanel.length >= 20;

    const TableData = {
        title: 'RTDS VIMS Files',
        storageString: 'library-management-panel-files',
        headerColumns: panelFilesHeadCells,
        sortableAccessors: panelFilesHeadCellsSortableAccessors,
        onRowSelection: setSelectedRows,
        data: panelTableData,
        id: 'rtds-files',
        setColumnVisibility,
        columnVisibility,
        setColumnOrder,
        columnOrder,
        tableContainer,
    };
    const getGenerationDisplayName = (genType: string): string => {
    const generation = generationOfDevices.find((gen) => gen.value === genType);
    return generation ? generation.title : genType;
  };
  const getGenerationValue = (displayName: string): string => {
    const generation = generationOfDevices.find((gen) => gen.title === displayName);
    return generation ? generation.value : displayName;
  };
   const panelConfigRepository = useCallback(async (generationOfDevice) => {
    try {
        const panelConfigurationManagement = new PanelConfigurationManagement(client, envVariables.panelConfigurationV1BaseUrl);
        const input: ConfigManagementRequestPayload = { generationType: generationOfDevice };
        const result = await panelConfigurationManagement.getPanelConfigurations(input);
        const configData = result.data.panelConfigs;
     setPanelTableData([]); 
            if (configData && configData.length) {
              setPanelTableData(
                configData.flatMap((config: any) =>
                  config.configurations.map((subConfig: any) => ({
                    id: subConfig.vimsSha1,
                    generationType: getGenerationDisplayName(subConfig.generationType),
                    vimsFileName: subConfig.vimsFileName,
                    vimsSha1: subConfig.vimsSha1,
                    fileName: subConfig.vimsFileName,
                    panelName: config.panelName,
                    vimsConfigId: subConfig.vimsConfigId,
                    isDefault: subConfig.isDefault,
                    subscriptionName: subConfig.subscriptionName,
                    updatedAt: subConfig.updatedAt,
                    updatedBy: subConfig.updatedBy,
                  }))
                ),
            );
        } else {
            setPanelTableData([]);
        }
        return null;
    } catch (error) {
        setPanelTableData([]);
        console.error('Failed to fetch panel configs:', error);
        return null;
    }
}, [client, envVariables.panelConfigurationV1BaseUrl]);

  useEffect(() => {
    dispatch(fetchVimsRtdsTableData('GLOBAL'));
    panelConfigRepository('GLOBAL');
  }, []);

    const onChangeGenerationOfDevice = (event: { target: { value: string } }) => {
      const newValue = event.target.value;
      setgenerationOfDevice(newValue);
      dispatch(fetchVimsRtdsTableData(newValue)); 
      panelConfigRepository(newValue);
    };
   const onChangePanelName = (event: { target: { value: string } }) => {
      const newValue = event.target.value;
      setPanelName(newValue);
    };
    const handleVimsSha = (event: any) => {
    const { value } = event.target;
    setVimsSha(value);
    if (value.trim()) {
      setVimsSha1(value.trim());
      setVimsConfigFile(null);
      setVimsConfigFileName('');
      setSelectFromexist(false);
    } else {
      setVimsSha1(undefined);
    }
  };
  // eslint-disable-next-line unicorn/consistent-function-scoping
    const selectVimsConfigFile = () => {
      setSelectFromexist(true);
      setVimsConfigFile(null);
      setVimsConfigFileName('');
      setVimsFileName(existingvimsFileName?.fileName);
      setVimsSha1(existingvimsFileName?.id);
      setVimsSha(existingvimsFileName?.id ?? '');
      setVimsConfigId(existingvimsFileName?.vimsConfigId);
      // eslint-disable-next-line @typescript-eslint/no-use-before-define
      closePopover();
      // eslint-disable-next-line @typescript-eslint/no-use-before-define
      resetSelection();
    };
    const closePopover = () => {
        setPopoverOpen(false);
    }
  const handleVimsConfigFileAccept = async () => {
  return new Promise<void>((resolve) => {
    const fileUploadData = {
      file: vimsConfigFile,
      fileName: vimsFileName,
      fileTypeId: '10330',
      overwrite: false,
      setPercentUpload,
      finishedCallback: (response: any) => {
        setVimsConfigFile(null);
        resolve();
      },
    };
    setVimsConfigFileUploadData(fileUploadData);
    dispatch(uploadVimsConfigFile(fileUploadData));
  });
  };
    const resetSelection = () => {
        setExistingVimsFileName(undefined);
        setSelectedItem(null);
    };
    const handleChange = (event: any) => {
       // eslint-disable-next-line prefer-destructuring
       let value = event.target.value
        value = value.replace(/^\s+/g, '').replace(/\s{2,}/g, ' ');
        setVimsFileName(value); 
    };

    const resetFields = () => {
      setVimsConfigFileName('');
      setVimsConfigFile(null);
      setPlanName('');
      setVimsFileName('');
      setRtdsConfigDefault(false);
      setVimsSha(''); 
      setVimsSha1(undefined); 
      setSelectFromexist(false);
    };
   // eslint-disable-next-line unicorn/consistent-function-scoping
   const resetEditFields = () => { 
      
    };

    const saveConfigApi = async () => {
      const input: any = {
        generationType: generationOfDevice,
        vimsFileName,
        vimsSha1,
        panelName,
        isDefault: rtdsConfigDefault,
        vimsConfigId,
        finishedCallback: (response: queueConfigManagementResponse) => {
        panelConfigRepository(generationOfDevice);
       },
      };
      dispatch(queuePanelConfigManagement(input));
    };
    /* eslint-disable unicorn/consistent-function-scoping */

  const saveConfigsActions = async () => {
    if (isPanelLimitReached) {
      dispatch(
        enqueueSnackbarAction({
          message: 'Maximum 20 configs allowed for this panel. Please delete an existing config to add a new one.',
          options: { variant: 'error' },
        })
      );
      return;
    }
    try {
      const asyncCalls = [];
      if (!vimsSha1) {
        asyncCalls.push(handleVimsConfigFileAccept());
      }
      await Promise.all(asyncCalls);
      await new Promise((resolve) => setTimeout(resolve, 500));
      await saveConfigApi();
    } catch (error) {
      console.error('Error in saveConfigsActions:', error);
    } finally {
      resetFields();
    }
  };

    const handleExistingVimsConfig = () => {
        setPopoverOpen(true);
    }

    const closeEditPopover = () => {
        setOpenEditPopoUp(false);
        resetEditFields()
    }

    const handleEditVimsConfig = (item:any) => {
        setOpenEditPopoUp(true);
        setEditSelectedRow(selectedRows);
        setVimsConfigRebootEdit(selectedRows[0].isReboot);
        setOriginalRtdsConfigDefaultEdit(selectedRows[0].isDefault); 
        setRtdsConfigDefaultEdit(selectedRows[0].isDefault);
    }

    const deleteConfigs = async (configs: any) => {   
      const deleteConfigRequest = {
          configs,
          userId: userName,
          applicationId: 'iot-gateway'
      };
     const response= await dispatch(deletePanelConfigManagement(deleteConfigRequest)) as any;
      if(response.status===200 || response.status===204){
      panelConfigRepository(generationOfDevice);
      }
    };
    const handleDeleteVimsConfig = (item: any) => {
      setDeleteSelectedRow(selectedRows);
      // eslint-disable-next-line array-callback-return
      const configs = selectedRows.map((item: any) => ({
        panelName: item.panelName,
        vimsConfigId: item.vimsConfigId,
      }));
      deleteConfigs(configs);
    };
    const editConfigManagement = async () => {
      closeEditPopover();
      const queueConfigRequest = {
        configs: [
          {
            generationType: getGenerationValue(editSelectedRow[0].generationType),
            vimsSha1: editSelectedRow[0].vimsSha1,
            vimsFileName: editSelectedRow[0].vimsFileName,
            panelName: editSelectedRow[0].panelName, 
            isDefault:
                  rtdsConfigDefaultEdit !== originalRtdsConfigDefaultEdit
                    ? rtdsConfigDefaultEdit
                    : editSelectedRow[0].isDefault,         
            vimsConfigId: editSelectedRow[0].vimsConfigId,
          },
        ],
        userId: userName,
        applicationId: 'iot-gateway',
      };
     const response= await dispatch(patchPanelConfigManagement(queueConfigRequest)) as any;
      if(response.status===200 || response.status===204){
      panelConfigRepository(generationOfDevice);
      }
    };

    return (
      <div className={classes.scrollBox}>
        <Grid container spacing={3} sx={{ mb: 3 }}>
          <Grid item xs={12}>
            <Box display="flex" alignItems="center" gap={6}>
              <Typography variant="h6" sx={{ mr: 1, whiteSpace: 'nowrap' }}>
                Select Gen Type<span style={{ color: 'red', fontWeight: 'bold' }}>*</span>
              </Typography>
              <Select
                variant="standard"
                id="generationDevice"
                value={generationOfDevice}
                onChange={onChangeGenerationOfDevice}
                className={classes.dropdown}
              >
                <MenuItem value="" disabled>
                  <em className={classes.unSelected}>Select</em>
                </MenuItem>
                {(generationOfDevices as Array<SelectOption>).map((o: SelectOption) => (
                  <MenuItem key={o.value} value={o.value}>
                    {o.title}
                  </MenuItem>
                ))}
              </Select>
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Box display="flex" alignItems="center" gap={6}>
              <Typography variant="h6" sx={{ mr: 4, whiteSpace: 'nowrap' }}>
                Select Panel<span style={{ color: 'red', fontWeight: 'bold' }}>*</span>
              </Typography>
              <Select
                variant="standard"
                id="panelName"
                value={panelName}
                onChange={onChangePanelName}
                className={classes.dropdown}
              >
                <MenuItem value="" disabled>
                  <em className={classes.unSelected}>Select</em>
                </MenuItem>
                {(Panels as Array<SelectOption>).map((o: SelectOption) => (
                  <MenuItem key={o.value} value={o.value}>
                    {o.title}
                  </MenuItem>
                ))}
              </Select>
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Box display="flex" alignItems="center" gap={7}>
              <Typography variant="h6" sx={{ mr: 1, whiteSpace: 'nowrap' }}>
                VIMS File Name <span style={{ color: 'red', fontWeight: 'bold' }}>*</span>
              </Typography>
              <TextField
                variant="standard"
                margin="none"
                className={classes.textField}
                id="vims-file-name-input"
                label={ selectFromexist ? '' : 'File Name'}
                onChange={handleChange}
                value={vimsFileName}
                title={vimsFileName}
                required={!vimsConfigFile}
                inputProps={{ maxLength: 32 }}
                disabled={!selectFromexist}
              />
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Box display="flex" alignItems="center" gap={1}>
              <Box display="flex" alignItems="center" gap={11}>
                <Typography variant="h6" sx={{ whiteSpace: 'nowrap' }}>
                  VIMS Config <span style={{ color: 'red', fontWeight: 'bold' }}>*</span>
                </Typography>
                <TextField
                  variant="standard"
                  margin="none"
                  id="vims-sha-input"
                  className={classes.textField}
                  label={vimsSha ? '' : 'VIMS SHA'}
                  onChange={handleVimsSha}
                  value={vimsSha}
                  title={vimsSha}
                  disabled={!!vimsConfigFile || selectFromexist}
                  required
                />
              </Box>
              <Button
                className={classes.button}
                variant="outlined"
                size="small"
                onClick={() => handleExistingVimsConfig()}
                disabled={
                  !generationOfDevice || (!!vimsSha.trim() && !selectFromexist && !vimsConfigFile)
                }
              >
                SELECT FROM EXISTING FILE
              </Button>
              <input
                type="checkbox"
                checked={rtdsConfigDefault}
                onChange={(event) => setRtdsConfigDefault(event.target.checked as boolean)}
                className={classes.leftAlign}
              />
              <Typography display="inline" sx={{ mr: 1 }}>Is Default Required</Typography>
            </Box>
          </Grid>
        </Grid>
        <div className={classes.actionRow}>
          <Button
            className={classes.saveButton}
            variant="outlined"
            size="small"
            onClick={() => saveConfigsActions()}
            disabled={
              !generationOfDevice ||
              !(vimsConfigFile || vimsSha1) ||
              !vimsFileName || !panelName
            }
          >
            Save Configs
          </Button>
        </div>
        <Box pt={3}>
          <Typography variant="h6">PANEL Config Repository</Typography>
          <div className={classes.actionRow}>
            <Button
              className={classes.button}
              variant="outlined"
              size="small"
              onClick={(item) => handleDeleteVimsConfig(item)}
              disabled={!selectedRows?.length}
            >
              Delete Selected
            </Button>
            <Button
              className={classes.button}
              variant="outlined"
              size="small"
              onClick={(item) => handleEditVimsConfig(item)}
              disabled={!selectedRows?.length}
            >
              Edit Selected
            </Button>
          </div>
        </Box>
        <div ref={tableContainer} className={classes.tableContainer}>
          <Table {...TableData} />
        </div>
        <Dialog
          open={popoverOpen}
          PaperProps={{
            style: {
              overflow: 'auto',
              minWidth: 700,
              width: 900,
              maxWidth: '95vw',
              maxHeight: '90vh',
            },
          }}
          PaperComponent={Paper}
          className={classes.dialog}
          maxWidth={false}
        >
          <Paper elevation={24}>
            <DialogContent>
              <Box p={2}>
                <Box pb={2}>
                  <Typography variant="h6" mb={1}>
                    VIMS Config List
                  </Typography>
                  <Divider />
                  {/* {modalData && ( */}
                  <div ref={vimsTableContainer} className={classes.vimsTableContainer}>
                    <VirtualizedTable
                      sortableAccessors={vimsConfigSortableAccessors}
                      columns={columns}
                      data={uniqueVimsFiles}
                      itemCount={uniqueVimsFiles.length}
                      tableContainer={vimsTableContainer}
                      loading={isLoading}
                    />
                  </div>
                  {/* )} */}
                </Box>
                <Box
                  display="flex"
                  flexGrow={1}
                  alignItems="center"
                  justifyContent="flex-end"
                  pr={2}
                >
                  {selectedItem && (
                    <>
                      <Box px={1}>
                        <Typography variant="h6">Selected Configs:</Typography>
                      </Box>
                      <Box px={1} flexGrow={0} overflow="hidden">
                        <Typography className={classes.overFlowEllipsis}>{selectedItem}</Typography>
                      </Box>
                      <Box px={1} pr={2}>
                        <IconButton
                          className={classes.iconButton}
                          id="queue-files-delete-selection"
                          onClick={() => resetSelection()}
                          aria-label="edit"
                          size="large"
                        >
                          <CancelIcon />
                        </IconButton>
                      </Box>
                    </>
                  )}
                  <DialogActions>
                    <Button
                      onClick={() => closePopover()}
                      variant="outlined"
                      size="small"
                      color="primary"
                    >
                      Cancel
                    </Button>
                    <Button
                      onClick={(item) => selectVimsConfigFile()}
                      variant="outlined"
                      size="small"
                      color="primary"
                      endIcon
                      disabled={!selectedItem}
                    >
                      Select Vims Config File
                    </Button>
                  </DialogActions>
                </Box>
              </Box>
            </DialogContent>
          </Paper>
        </Dialog>
        <Dialog
          open={openEditPopUp}
          PaperComponent={Paper}
          className={classes.dialog}
          maxWidth="lg"
        >
          <Paper elevation={24}>
            <DialogContent>
              <Box p={2}>
                <Grid container direction="row" alignItems="stretch" mt="20px">
                  <Grid item xs={12}>
                    <Box display="flex" alignItems="center" gap={2}>
                      <Typography variant="h6" sx={{ mr: 1, whiteSpace: 'nowrap' }}>
                        VIMS File Name <span style={{ color: 'red', fontWeight: 'bold' }}>*</span>
                      </Typography>
                      <TextField
                        variant="standard"
                        margin="none"
                        size="small"
                        className={classes.textField}
                         sx={{ width: 150 }} 
                        value={editSelectedRow[0]?.vimsFileName}
                        inputProps={{ maxLength: 32 }}
                        // eslint-disable-next-line unicorn/prevent-abbreviations
                        onChange={e => {
                          const updated = [...editSelectedRow];
                          updated[0] = { ...updated[0], vimsFileName: e.target.value };
                          setEditSelectedRow(updated);
                        }}
                      />
                      <Box display="flex" alignItems="center">
                        <input
                          type="checkbox"
                          checked={rtdsConfigDefaultEdit}
                          onChange={(event) => {
                            setRtdsConfigDefaultEdit(event.target.checked as boolean);
                          }}
                          className={classes.leftAlign}
                        />
                        <Typography>Is Default Required</Typography>
                      </Box>
                    </Box>
                  </Grid>
                </Grid>
              </Box>
              <DialogActions>
                <Button
                  onClick={() => closeEditPopover()}
                  variant="outlined"
                  size="small"
                  color="primary"
                >
                  Cancel
                </Button>
                <Button
                  onClick={() => editConfigManagement()}
                  variant="outlined"
                  size="small"
                  color="primary"
                  endIcon
                  disabled={
                    editSelectedRow[0]?.vimsFileName === selectedRows[0]?.vimsFileName &&
                    rtdsConfigDefaultEdit === originalRtdsConfigDefaultEdit
                  }
                >
                  Edit
                </Button>
              </DialogActions>
            </DialogContent>
          </Paper>
        </Dialog>
      </div>
    );
};

export default PanelConfigurations;
